import { render } from "./my-profile.vue?vue&type=template&id=faa0ec70&scoped=true"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"

import "./my-profile.vue?vue&type=style&index=0&id=faa0ec70&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa0ec70"]])

export default __exports__